import React from 'react';

export function FruitPage() {
  return (
    <div>
        <div className="mb-8">
          <h1 className="text-neutral-900">Fruit</h1>
          <p className="text-neutral-600 mt-1">Manage fruit inventory</p>
        </div>
      </div>
  );
}

export default FruitPage;
